import { Box, Container } from "components/core";

import ErrorMessage from "./error-message";

/**
 * This is displayed when there is an error that React cannot continue
 * rendering from i.e. what is shown as a fallback when catching
 * with `ErrorBoundary`.
 */
const ErrorPage = () => {
  const copyVersion = Math.floor(Math.random() * 3);

  return (
    <Container maxWidth="sm">
      <Box px={[3, 4]} py={8} textAlign="center">
        <ErrorMessage mx="auto" version={copyVersion} />
      </Box>
    </Container>
  );
};

export default ErrorPage;
